import { render, staticRenderFns } from "./Opponents.vue?vue&type=template&id=bdb96534&scoped=true"
import script from "./Opponents.vue?vue&type=script&lang=js"
export * from "./Opponents.vue?vue&type=script&lang=js"
import style0 from "./Opponents.vue?vue&type=style&index=0&id=bdb96534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb96534",
  null
  
)

export default component.exports